// hooks/useOnlineSuggestionTelemetry.ts
'use client'

import { useEffect, useMemo } from 'react'
import { makePublicEventSender, makeSuggestionTelemetry, type SuggestionTelemetry } from '@/lib/suggestions/telemetry'

/**
 * Telemetría de la hoja de sugerencias de la tienda online (PR 5c). Delgado a
 * propósito: la lógica vive en lib/suggestions/telemetry (probada sin DOM).
 * Sin token (ruta pública) y sin store que cablear: los tres eventos los
 * dispara RestaurantMicrosite donde ocurren (impresión al resolver, tap al
 * tocar, enlace al confirmar el pedido). `enabled` = el dueño tiene las
 * sugerencias de la tienda encendidas; apagado devuelve null.
 */
export function useOnlineSuggestionTelemetry({ locationId, enabled }: { locationId: string; enabled: boolean }): SuggestionTelemetry | null {
  const telemetry = useMemo(() => {
    if (!enabled) return null
    return makeSuggestionTelemetry({ send: makePublicEventSender({ locationId }) })
  }, [enabled, locationId])

  useEffect(() => {
    if (!telemetry) return
    const onHide = () => telemetry.flush()
    window.addEventListener('pagehide', onHide)
    return () => {
      window.removeEventListener('pagehide', onHide)
      telemetry.flush()
    }
  }, [telemetry])

  return telemetry
}
